import { Result } from "antd";
import React, { Component } from "react";
import { connect } from "react-redux";
import { FooterButtons } from "../../../../PickerOrder/PickerOrderPage/PickerOrderPage.styled";
import { withRouter } from "react-router-dom";
import { CURRENT_BOX } from "../../../../../constants";

export class TOPOFinalScreen extends Component {
  componentDidMount = () => {
    localStorage.removeItem(CURRENT_BOX);
  };
  render() {
    let { isError } = this.props;
    return (
      <div className="centerScreen">
        <Result
          status={`${isError ? "warning" : "success"}`}
          title={`${
            isError ? "Issue found while picking" : "All medicines are picked"
          }`}
        />

        <FooterButtons>
          <button
            className="bbtn"
            onClick={() => this.props.history.push("/to-picker")}
          >
            Go to home
          </button>
        </FooterButtons>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(TOPOFinalScreen)
);
